import polyline from '@mapbox/polyline'
import GeoJSONFormat from 'ol/format/GeoJSON'
import WFSFormat from 'ol/format/WFS'
import WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo'
import { DATA_PROJECTION, MAP_PROJECTION } from '../../constants'

const formats = {
  geojson: new GeoJSONFormat(),
  wms: new WMSGetFeatureInfo(),
  wfs: new WFSFormat(),
}

export const createFeatures = (features, format = 'geojson') => {
  return formats[format].readFeatures(features, {
    dataProjection: DATA_PROJECTION,
    featureProjection: MAP_PROJECTION,
  })
}

export const createGeoJsonFeature = (geometry, properties = {}) => {
  // Handle different types of inputs
  const geom = typeof geometry === 'string' ? JSON.parse(geometry) : geometry

  // Ensure we have a valid geometry
  if (!geom) {
    console.error('Invalid geometry provided to createGeoJsonFeature')
    return null
  }

  // Create a feature with the geometry and properties
  const feature = {
    type: 'Feature',
    properties: properties,
    geometry: geom,
  }

  return feature
}

export const encode = geoJsonGeom => {
  let input = []
  switch (geoJsonGeom.type) {
    case 'Point':
      input = [geoJsonGeom.coordinates]
      break
    case 'Linestring':
      input = geoJsonGeom.coordinates
      break
    case 'Polygon':
      input = geoJsonGeom.coordinates[0]
      break
  }
  return polyline.encode(input)
}

export const decode = encodedGeom => {
  const coords = polyline.decode(encodedGeom)

  if (!coords) {
    return false
  }

  if (
    coords.length === 1 &&
    coords[0].length === 2 &&
    typeof coords[0][0] == 'number' &&
    typeof coords[0][1] == 'number'
  ) {
    return {
      type: 'Point',
      coordinates: coords[0],
    }
  } else if (
    coords.length > 3 &&
    JSON.stringify(coords[0]) === JSON.stringify(coords[coords.length - 1])
  ) {
    return {
      type: 'Polygon',
      coordinates: [coords],
    }
  } else {
    return {
      type: 'Linestring',
      coordinates: coords,
    }
  }
}
